/* global $ */

// If filters exist on page
if ($('.filters')) {
	// Invoke Selectric styles for <select> boxes
	$('.filters select').selectric();

	// Hide Submit button on filter areas
	$('.searchandfilter .sf-field-submit').hide();

	// Add fixed Type label to News Post filter
	// $('.sf-field-category .selectric').prepend(
	// 	'<span class="fixed-label">Type</span>'
	// );

	// Add fixed Topic label to News Post filter
	// $('.sf-field-taxonomy-news-post-topic .selectric').prepend(
	// 	'<span class="fixed-label">Topic</span>'
	// );

	// Change selectric arrow to svgs
	$('.selectric .button').replaceWith(
		'<button class="selectric-button"><svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.76244 -0.000119324L-2.85105e-05 6.24123L1.11278 7.38232L6.76244 2.16803L12.4121 7.38232L13.5249 6.24124L6.76244 -0.000119324Z" fill="#46728A"/></svg><span class="screen-reader-text">Open and close the filter menu. Submits on close.</span></button>'
	);

	// Use change function to submit filter areas
	$('.filters select').on('change', () => {
		$('.searchandfilter .sf-field-submit [type="submit"]').click();
	});

	$(
		'.filters [data-sf-field-input-type="checkbox"] li, .filters [data-sf-field-input-type="radio"] li'
	).on('change', () => {
		$('.searchandfilter .sf-field-submit [type="submit"]').click();
	});
}
